import { Component, OnInit, Input, ViewChild, OnDestroy,TemplateRef } from '@angular/core';
import { Logger } from '@app/core';
import { ReportsStructureConfig } from './shared/reports-structure.config.service';
import { LocalDataSource } from 'ng2-smart-table';
import { ReportsStructureDataService } from './shared/reports-structure.data.service';
import { ReportsStructureFormService } from './shared/reports-structure.form.service';
import { ToastrService } from 'ngx-toastr';
import {
  EstructuraReporte,
  BaseControl,
  ConfirmComponent,
  ColumnaFuenteDatosEstructura,
  Option
} from '@app/shared';
import { Subject } from 'rxjs';

const log = new Logger('ReportsStructureComponent');

@Component({
  selector: 'iw-reports-structure',
  templateUrl: './reports-structure.component.html',
  styleUrls: ['./reports-structure.component.scss'],
  providers: [ReportsStructureDataService, ReportsStructureFormService]
})
export class ReportsStructureComponent implements OnInit, OnDestroy {

  // Contiene el id del reporte seleccionado
  @Input() idReport = -1;
  // Contiene el tipo del reporte seleccionado
  @Input() reportType = '';
  // Contiene las extenciones para la imagen
  @Input() extensions: string[] = [
    'image/jpeg',
    'image/png',
    'image/jpeg'
  ];
  // Contiene el id de la colmna de estructura seleccionada
  idStructureReport = -1;
  // Texto de accion en el formulario
  actionForm = '';
  // Pregunta de la modal
  question = '';
  // Define cuando mostrar el formulario
  openForm = false;
  // Defini si la accion es editar o agregar
  edictAction = false;
  // Configuracion de la tabla
  settings = {};
  // contiene temporalmente los datos de la columna seleccionada
  tempData = {};
  // contiene temporalmente los datos de la columna seleccionada
  tempOperations = {};
  // Datos para llenar la tabla
  sourceData: LocalDataSource;
  // Contiene los controles de el formulario de asociaciones
  controls: BaseControl<any>[] = [];
  // Contiene los tipos de parametros de los reportes
  typesParameters: Option[] = [];
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  // Contiene la estructura de la fuente de datos
  structureDataSource: ColumnaFuenteDatosEstructura = {};
  // define si ha subido documento
  documentUpload = false;
  // contiene los datos de la imagen para el control
  image_file: any = null
  // Referencia al componente de confirmación
  @ViewChild('confirm') private confirm: ConfirmComponent;
  // Referencia a la plantilla para el control personalizado de cargar documento
  @ViewChild('fileUpload') fileUpload: TemplateRef<any>;

  extensionsAccept = '';

  constructor(
    private rsds: ReportsStructureDataService,
    private rsfs: ReportsStructureFormService,
    private toastr: ToastrService,
  ) { }

  ngOnInit() {
    // Se inicia la configuracion de la tabla
    const configTable = new ReportsStructureConfig();
    if (this.reportType && this.reportType =='Experto'){
      this.settings = configTable.settingsExpert;
    }else{
      this.settings = configTable.settings;
    }
    configTable.accion.subscribe((data: any) => {
      log.debug(data);
      this.defineAction(data.action, data.data);
    });
    this.rsds.getTypesParametersReports().subscribe(data => {
      if (data && data.length) {
        data.forEach(el => {
          this.typesParameters.push({
            key: el.id, value: el.descripcion, others: el.nombre
          });
        });
      }
    });
    this.loadingStuctureReport();
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  /**
   * Define o controla las acciones a realizar
   *
   * @param {('add' | 'update' | 'delete' | 'close')} [action='add']
   * @param {EstructuraReporte} [data]
   * @param {boolean} [setIdReport=true]
   * @memberof ReportsStructureComponent
   */
  defineAction(
    action: 'add' | 'update' | 'delete' | 'close' = 'add',
    data?: EstructuraReporte,
    setIdReport: boolean = true
  ) {
    switch (action) {
      case 'update':
        this.actionForm = 'Modificar';
        this.openForm = true;
        this.idStructureReport = data.id;
        this.tempOperations = data.operaciones;
        this.tempData = data.dato;
        this.controls = this.rsfs.getForm(this.typesParameters, data, this.reportType, this.fileUpload);
        this.edictAction = true;
        break;
      case 'close':
        this.actionForm = '';
        this.openForm = false;
        this.edictAction = false;
        this.tempOperations = {};
        this.tempData = {};
        if (setIdReport) {
          this.idStructureReport = -1;
        }
        this.question = '';
        break;
      case 'delete':
        this.actionForm = '';
        this.openForm = false;
        this.edictAction = false;
        this.idStructureReport = data.id;
        this.question = '¿Realmente desea eliminar el reporte?';
        this.confirm.open();
        break;
      default:
        this.actionForm = 'Agregar';
        this.controls = this.rsfs.getForm(this.typesParameters, data, this.reportType, this.fileUpload);
        this.openForm = true;
        this.edictAction = false;
        this.idStructureReport = -1;
        break;
    }
  }

  /**
   * Guarda o edita la estructura de un reporte
   *
   * @param {*} data
   * @param {(ColumnaFuenteDatosEstructura | false)} dataSource
   * @memberof ReportsStructureComponent
   */
  sended(data: any, dataSource:  ColumnaFuenteDatosEstructura | false) {
    if (dataSource !== false) {
      // crea el objeto de la estrutura inicial
      const structure: EstructuraReporte = {
        nombre: data.txtNombre,
        celda: data.txtCelda,
        orden: data.txtOrden,
        operaciones: this.tempOperations,
        dato: dataSource,
        reporte: this.idReport,
        estatico: data.chkEstatico,
        tipo_campo: data.cboTipoCampo,
        alias: data.txtAlias,
        imagen: this.image_file
      };
      // valida si la estructura lleva operaciones o una fuente datos o la columna es de tipo estatica
      //Pusimos el campo operaciones como opcional en el archivo reporte.model.ts, PENDIENTE VERIFICAR SI ES POSIBLE YA QUE PARA PODER HACER REFERENCUA DE UNA CELDA EN LA MISMA FLA PARA LAS OPERACIONES DE EXCEL
      if (Object.keys(structure.operaciones).length || Object.keys(structure.dato).length || data.chkEstatico || this.reportType =='Experto') {
        // Valida si es una columna ah agregar o editar
        if (!this.edictAction) {
          this.rsds.addStructureReports(structure).subscribe(resp => {
            if (resp) {
              this.loadingStuctureReport();
              this.defineAction('close');
              this.image_file = null;
            }
          });
        } else {
          this.rsds.updateStructureReports(this.idStructureReport, structure).subscribe(resp => {
            if (resp) {
              this.loadingStuctureReport();
              this.defineAction('close');
              this.image_file = null;
            }
          });
        }
      } else {
        this.toastr.error('La columna debe contener una operacion o una fuente de datos', 'Información incompleta');
      }
    } else {
      this.toastr.error('Falta información en la pestaña de fuente de dato', 'Información incompleta');
    }
  }

  /**
   * Controla la confirmacion del usuario en la accion de la modal de confirmacion
   *
   * @param {boolean} resp
   * @memberof ReportsStructureComponent
   */
  actionComfirm(resp: boolean) {
    if (resp) {
      this.deleteStructureReport();
    }
  }

  /**
   * Guarda la operacion agregada a la columna
   *
   * @param {*} data
   * @memberof ReportsStructureComponent
   */
  savedOperations(data: any) {
    if (data) {
      this.tempOperations = data;
    }
  }

  /**
   * Consulta y carga la estructura del reporte seleccionado
   *
   * @private
   * @memberof ReportsStructureComponent
   */
  private loadingStuctureReport() {
    if (this.idReport !== -1) {
      this.rsds.getStructureReports(this.idReport).subscribe(data => {
        this.sourceData = new LocalDataSource(data);
      });
    }
  }

  /**
   * Elimina la columna del reporte seleccionada
   *
   * @private
   * @memberof ReportsStructureComponent
   */
  private deleteStructureReport() {
    if (this.idReport !== -1) {
      this.rsds.deleteStructureReports(this.idStructureReport).subscribe(resp => {
        if (resp) {
          this.loadingStuctureReport();
          this.defineAction('close');
        }
      });
    }
  }
  
  /**
   * Controla el evento de cargar un documento de rótulo
   *
   * @private
   * @param {*} data
   * @returns {*}
   * @memberof StampComponent
   */
   private onAdded(data: any): any {
    this.image_file = data.file
 }

/**
 * Remueve el documento cargado
 *
 * @returns {*}
 * @memberof LoadInformationExcelComponent
 */
 onRemoved(): any {
  this.image_file = null
  this.documentUpload = false;
}

  /**
   * Agregar o remover un documento
   *
   * @param {*} data
   * @returns {*}
   * @memberof StampComponent
   */
   onAction(data: any): any {
    if (data.action === 1) {
      this.onAdded(data);
    } else if (data.action === 0) {
      this.onRemoved();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/management-reports/reports/reports-structure/reports-structure.component.ts